import { z } from 'zod'
import { companyRole } from './company-role'

export const companyUser = z.object({
    userId: z.string(),
    companyId: z.string(),
    role: companyRole,
    name: z.string().optional(),
    email: z.string().optional(),
    avatar: z.string().optional(),
})

export type CompanyUser = z.infer<typeof companyUser>
